import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
  import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-addupdatebannerpopup',
  templateUrl: './addupdatebannerpopup.component.html',
  styleUrl: './addupdatebannerpopup.component.css'
})
export class AddupdatebannerpopupComponent {







bannerForm!: FormGroup;

selectedFile: File | null = null;
imagePreview: string | null = null;

constructor(
  private fb: FormBuilder,
  private apiService: ApiService,
  private toastrService: ToastrService,
  private dialogRef: MatDialogRef<any>,
  @Inject(MAT_DIALOG_DATA) public data: any
) {}

ngOnInit(): void {

  // this.bannerForm = this.fb.group({
  //   id: [0],
  //   bannerName: ['', Validators.required],
  //   sortOrder: [1, Validators.required],
  //   redirectUrl: [''],
  //   isActive: [true],
  //   imageUrl: ['']
  // });


  this.bannerForm = this.fb.group({
     id: [0],
    bannerName: ['', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(100)
    ]],
   sortOrder: [1, Validators.required],
    redirectUrl: ['', [

      Validators.pattern('https?://.+')
    ]],
    isActive: [true]
  });


  if (this.data?.mode === 'edit' && this.data?.element) {

  this.isEditMode = true;
      this.isReadOnly = true;
    this.bannerForm.patchValue({
      id: this.data.element.Id,
      bannerName: this.data.element.BannerName,
      sortOrder: this.data.element.SortOrder,
      redirectUrl: this.data.element.RedirectUrl,
      isActive: this.data.element.IsActive,
      imageUrl: this.data.element.ImageUrl
    });

    this.imagePreview = this.data.element.ImageUrl;



                
  }
}

isReadOnly = false;

isEditMode = false;


  closePopup() {
    this.dialogRef.close();
  }


// onFileSelected(event: any) {

//   const file = event.target.files[0];

//   if (file) {
//     this.selectedFile = file;

//     const reader = new FileReader();
//     reader.onload = () => {
//       this.imagePreview = reader.result as string;
//     };

//     reader.readAsDataURL(file);
//   }
// }

onFileSelected(event: any): void {

  const file = event.target.files[0];

  if (!file) {
    return;
  }

  // File Size Validation (5 MB)
  const maxSize = 5 * 1024 * 1024; // 5 MB

  if (file.size > maxSize) {
    this.toastrService.error('File size must not exceed 5 MB.');
    event.target.value = '';
    this.selectedFile = null;
    this.imagePreview = '';
    return;
  }

  // Image Dimension Validation
  const img = new Image();

  img.onload = () => {

    if (img.width !== 1238 || img.height !== 651) {

      this.toastrService.error(
        'Image dimensions must be exactly 1238 × 651 pixels.'
      );

      event.target.value = '';
      this.selectedFile = null;
      this.imagePreview = '';
      return;
    }

    // Valid Image
    this.selectedFile = file;

    const reader = new FileReader();

    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };

    reader.readAsDataURL(file);
  };

  img.onerror = () => {
    this.toastrService.error('Invalid image file.');
    event.target.value = '';
  };

  img.src = URL.createObjectURL(file);
}
saveBanner() {

  if (this.bannerForm.invalid) {
    this.bannerForm.markAllAsTouched();
    return;
  }

  const formValue = this.bannerForm.value;

  const formData = new FormData();

  formData.append('Id', (formValue.id || 0).toString());
  formData.append('BannerName', formValue.bannerName || '');
  formData.append('SortOrder', (formValue.sortOrder || 0).toString());
  formData.append('RedirectUrl', formValue.redirectUrl || '');
  formData.append('IsActive', String(formValue.isActive));
  formData.append('ImageUrl', formValue.imageUrl || '');

  if (this.selectedFile) {
    formData.append('File', this.selectedFile);
  }

  this.apiService
    .postRequest(API_ENDPOINTS.MSSIDC.insertUpdateBanner, formData)
    .subscribe({
      next: (resp: any) => {

        if (resp?.status) {
          this.toastrService.success(resp.message);
          this.dialogRef.close(true);
        } else {
          this.toastrService.error(resp?.message || 'Failed to save banner');
        }

   

      },
      error: (err) => {
        this.toastrService.error(err?.error?.message || 'Something went wrong');
      }
    });
}
}
